// Tenants are database rows, created via the admin — no code changes needed
// for a new tenant. Etcho is the one exception: it is seeded by migration with
// this well-known ID so existing data can be assigned to it deterministically
// and fallback logic (e.g. unknown hostname → Etcho branding) can reference it.
export const ETCHO_TENANT_ID = '9a611b26-acbb-4f84-8308-bb9407877a40';

export const ETCHO_TENANT_SLUG = 'etcho';
